import { Preferences } from '@capacitor/preferences';
import { isNativeMobileApp } from './platform';

export const SESSION_STORAGE_KEYS = Object.freeze([
  'correfood_token',
  'correfood_user',
  'correfood_access_code',
]);

function canUseWebStorage() {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

export async function hydrateSessionFromNativeStorage() {
  if (!isNativeMobileApp() || !canUseWebStorage()) return;

  await Promise.all(
    SESSION_STORAGE_KEYS.map(async (key) => {
      try {
        const result = await Preferences.get({ key });
        if (result?.value == null) return;
        window.localStorage.setItem(key, result.value);
      } catch {
        // Ignora falhas de leitura para nao bloquear o bootstrap.
      }
    }),
  );
}

export async function mirrorSessionValue(key, value) {
  if (!isNativeMobileApp()) return;

  try {
    const rawValue = value == null ? '' : String(value);
    if (!rawValue) {
      await Preferences.remove({ key });
      return;
    }
    await Preferences.set({ key, value: rawValue });
  } catch {
    // Melhor-esforco: localStorage continua sendo fonte primaria no frontend.
  }
}

export async function mirrorSessionRemoval(keys) {
  if (!isNativeMobileApp()) return;

  const list = Array.isArray(keys) ? keys : [keys];
  await Promise.all(
    list.map(async (key) => {
      if (!key) return;
      try {
        await Preferences.remove({ key: String(key) });
      } catch {
        // Melhor-esforco.
      }
    }),
  );
}
